<template>
  <div class="permission-group">
    <div class="permission-group__header">{{ group.name }} {{ outOf }}</div>
    <ul class="permission-group__abilities">
      <li
        v-for="normalized in normalizedPermissions"
        :key="normalized.id"
      >
        <ToolTip :content="normalized.info">
          {{ normalized.name }}
        </ToolTip>
      </li>
    </ul>
  </div>
</template>

<script lang="ts">
export default {
  name: 'PermissionGroup',
}
</script>

<script lang="ts" setup>
import { computed } from 'vue'

import { useAuthStore } from '@/modules/Auth/useAuthStore'

import { GROUPED_ABILITIES, ABILITY_INFO } from './data'
import type { AbilityID, ApiKeyPermission, Group } from './types'
import ToolTip from '@/uiKit/ToolTip/ToolTip.vue'

const props = defineProps<{ group: Group & { permissions: ApiKeyPermission[] } }>()

const authStore = useAuthStore()

const abilities = computed(() => {
  const actions = authStore.abilities.reduce(
    (acc, a) => acc.concat(a.actions as AbilityID[]),
    [] as AbilityID[],
  )

  return GROUPED_ABILITIES[props.group.id].filter((action) => actions.includes(action))
})

const normalizedPermissions = computed(() =>
  props.group.permissions.map((permission) => ({
    id: permission[0],
    name: ABILITY_INFO[permission[0]].name,
    info: ABILITY_INFO[permission[0]].info,
    original: permission,
  })),
)

const outOf = computed(
  () => `${normalizedPermissions.value.length} / ${abilities.value.length} authorisations`,
)
</script>

<style lang="scss" scoped>
.permission-group {
  &__header {
    color: var(--color-text-subtle);
    @include typographyRegularBody200;
  }

  &__abilities {
    color: var(--color-text-subtlest);
    @include typographyRegularBody200;

    padding-left: 16px;
    margin: 0;
  }
}
</style>
